{
    "absence": {
        "balance_history": {
            "empty_state": "No absences found for {{year}}.",
            "filter_all_groups": "All groups",
            "get_absence_sheet": "",
            "title": "Balance history"
        },
        "details": {
            "action_approve_withdrawal": "Approve Withdrawal",
            "action_cancel": "Withdraw Absence",
            "action_deny_withdrawal": "Deny Withdrawal",
            "action_request": "Request",
            "change_requested": "Requested change",
            "events_on": "Events on",
            "field_dates": "Dates",
            "field_duration": "Duration",
            "field_hours": "Hours",
            "field_notes_hr": "Notes HR",
            "field_reason": "Reason",
            "field_vacation_balance": "Available vacation balance",
            "locked_by": "{{name}} is editing this employee right now.",
            "locked_message": "This user is currently locked for editing.",
            "remove_dialog_body": "This action will permanently remove your time-off request for",
            "title": "Absence details",
            "withdrawal_asked_on": "Requested",
            "withdrawal_awaiting": "Awaiting",
            "withdrawal_requested": "Withdrawal requested"
        },
        "duration": {
            "day_one": "{{count}} day",
            "day_other": "{{count}} days",
            "hour_one": "{{count}} hour",
            "hour_other": "{{count}} hours"
        },
        "legend": {
            "status_pending": "Pending Approval",
            "status_tentative": "Tentative",
            "status_unspecified": "Unspecified Absence",
            "title": "Legend"
        },
        "page_header": {
            "group_civil_days": "",
            "group_family_leave": "",
            "group_health_leave": "",
            "group_vacation": "",
            "tooltip_schedule": "Schedule time off"
        },
        "page_title": "Absence",
        "schedule": {
            "title": "Schedule absence",
            "withdraw_title": "Withdraw absence"
        },
        "timeline": {
            "days_off_left": "Days off left",
            "nav_next_day": "Next Day",
            "nav_next_month": "Next Month",
            "nav_next_week": "Next Week",
            "nav_previous_day": "Previous Day",
            "nav_previous_month": "Previous Month",
            "nav_previous_week": "Previous Week",
            "search_members": "Search Members",
            "view_day": "Day",
            "view_month": "Month"
        }
    },
    "alerts": {
        "alert_image_alt": "Alert image",
        "collapse_alert_row_tooltip": "Collapse [click row]",
        "create_alert": "Create Alert",
        "creator": "Creator",
        "date_time": "Date/Time",
        "description": "Description",
        "edit_alert_tooltip": "Edit [double-click row]",
        "expand_alert_row_tooltip": "Expand [click row]",
        "finish_current_edit_first": "Save or discard current changes first",
        "images_left_one": "{{count}} of 5 images left",
        "images_left_other": "{{count}} of 5 images left",
        "new_alert_notification": "New Alert!",
        "open_image_preview": "Open image preview",
        "opened": "Opened",
        "owned_cases": "Owned Cases",
        "page_title": "Alerts",
        "person_in_charge": "Person in Charge",
        "pic": "PIC",
        "reassign": "Reassign",
        "reassign_alert": "Reassign Alert",
        "resolution_notes": "Resolution Notes",
        "resolve_alert": "Resolve alert",
        "resolved": "Resolved",
        "show_image": "Show image {{index}}",
        "supervised_cases": "Supervised Cases",
        "title": "Title",
        "total_this_year": "Total this year",
        "up_to_5_files": "up to 5 Files",
        "validation_description_required": "Description is required",
        "validation_images_max": "You can upload up to 5 images",
        "validation_person_in_charge_required": "Person in Charge is required",
        "validation_type_required": "Type is required"
    },
    "auth": {
        "authenticator_qr_alt": "Authenticator QR",
        "back_to_login": "Back to login",
        "challenge_missing": "Challenge is missing",
        "change_password_button_title": "Change password",
        "default_enrollment_notice": "Check your email inbox.",
        "email_label": "Email",
        "enable_two_factor_authentication": "Enable Two-Factor Authentication",
        "enrollment_link_invalid_or_expired": "",
        "enrollment_token_missing": "",
        "forgot_password_link": "Forgot password?",
        "login": "Login",
        "manual_key": "Manual key: {{key}}",
        "manual_key_label": "Manual Key",
        "missing_challenge_token": "Missing challenge token.",
        "new_password_label": "New password",
        "otp_label": "Authenticator code",
        "password": "Password",
        "password_changed_successfully": "Password changed successfully.",
        "reset_confirm_hint": "Set a new password and enter your authenticator code.",
        "reset_password_title": "Reset Password",
        "reset_request_2fa_hint": "Reset works only if 2FA is enabled for your account.",
        "reset_request_enter_email": "Enter your email.",
        "reset_request_success": "If your account is eligible, a reset link was sent to your email.",
        "scan_qr_or_use_manual_key": "Scan this QR code in your authenticator app or use the manual key.",
        "send_reset_link": "Send reset link",
        "set_new_password_button": "Set new password",
        "two_factor_authentication": "Two-Factor Authentication",
        "use_another_account": "Use another account",
        "validation": {
            "email_invalid": "Email is invalid",
            "email_required": "Email is required",
            "otp_invalid": "Enter a valid 6-digit code",
            "otp_required": "Verification code is required",
            "password_min": "Password should have minimum 8 symbols",
            "password_required": "Password is required"
        },
        "verification_code_label": "Verification code",
        "verify_and_continue": "Verify and continue",
        "verify_otp_code_button": "Verify code"
    },
    "blocker": {
        "cancel_button": "Discard changes",
        "confirm_button": "Keep editing",
        "text": "You have unsaved changes. Discard them and continue?",
        "title": "Unsaved Changes"
    },
    "calendar": {
        "preset": {
            "all_dates": "All dates",
            "last_month": "Last month",
            "last_week": "Last week",
            "last_year": "Last year",
            "this_month": "This month",
            "this_week": "This week",
            "this_year": "This year"
        }
    },
    "choices_select": {
        "empty": "No options"
    },
    "common": {
        "active": "Active",
        "add": "Add",
        "all": "All",
        "apply_button_title": "Apply",
        "approve": "Approve",
        "balance_history": "Balance history",
        "cancel": "Cancel",
        "clear_all": "Clear all",
        "close": "Close",
        "compare": "Compare",
        "confirm": "Confirm",
        "copy_button": "Copy",
        "copy_button_copied": "Copied!",
        "copy_button_error": "Failed to copy",
        "date": "Date",
        "delete": "Delete",
        "deny": "Deny",
        "download": "Download",
        "drag": "Drag",
        "edit": "Edit",
        "end_date": "End Date",
        "filter": "Filter",
        "from": "From",
        "from_label": "From",
        "full_screen": "Full screen",
        "inactive": "Inactive",
        "internal_phone_book": "Internal phone book",
        "legend": "Legend",
        "mail": "Mail",
        "next": "Next",
        "none": "-- None --",
        "not_saved": "Changes were not saved",
        "notes": "Notes",
        "previous": "Previous",
        "quick_dial": "Quick Dial",
        "reference": "Reference",
        "required_field": "This field is required.",
        "reset_filters": "Reset filters",
        "save": "Save",
        "search": "Search",
        "set": "Set",
        "settings": "Settings",
        "show_more": "Show more",
        "start_date": "Start Date",
        "status": "Status",
        "tasks": "Tasks",
        "to": "To",
        "to_label": "To",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "try_again": "Try again",
        "type": "Type",
        "type_to_search": "Type to search",
        "update": "Update"
    },
    "dashboard": {
        "settings": "Dashboard Settings"
    },
    "fleet": {
        "add_vehicle": "Add vehicle",
        "assigned_driver": "Assigned Driver",
        "capacity": "Capacity",
        "chassis": "Chassis",
        "comment": "Comment",
        "commissioning_date": "Commissioning date",
        "consumption_count_one": "Consumption ({{count}})",
        "consumption_count_other": "Consumption ({{count}})",
        "cost": "Cost",
        "cost_currency": "Cost, {{currency}}",
        "cost_per_km": "Cost/km",
        "create_vehicle": "Create vehicle",
        "current_swap_body": "Current Swap Body",
        "data": "Data",
        "decommissioning_date": "Decommissioning date",
        "dimensions": "Dimensions",
        "dispatchable": "Dispatchable",
        "distance_year": "Distance {{year}}",
        "driven_year": "Driven {{year}}",
        "empty_weight": "Empty weight",
        "fuel": "Fuel",
        "fuel_l": "Fuel, L",
        "fuel_used_year": "Fuel used {{year}}",
        "general": "General",
        "gross_weight": "Gross weight",
        "group_load_error": "Vehicles could not be loaded.",
        "height": "Height",
        "hydraulic_platform": "Hydraulic platform",
        "import_vehicles": "Import vehicles",
        "length": "Length",
        "license": "License",
        "load_error": "Fleet could not be loaded.",
        "location": "Location",
        "maintenance_count_one": "Maintenance ({{count}})",
        "maintenance_count_other": "Maintenance ({{count}})",
        "make": "Make",
        "master_number": "Master number",
        "model": "Model",
        "not_saved": "Vehicle was not saved",
        "number": "Number",
        "operational": "Operational",
        "owner_branch": "Owner Branch",
        "page_title": "Fleet",
        "payload": "Payload",
        "photo": "Photo",
        "provider": "Provider",
        "purchase_price": "Purchase Price",
        "required_qualification": "Required qualification",
        "select_driver": "Select driver",
        "standard_trailer": "Standard trailer",
        "total": "total",
        "type": "Type",
        "user_branch": "User Branch",
        "validation_commissioning_date_required": "Commissioning date is required",
        "validation_decommissioning_date": "Decommissioning date cannot be before commissioning date",
        "validation_make_required": "Make is required",
        "validation_master_number_required": "Master number is required",
        "validation_model_required": "Model is required",
        "validation_number_required": "Number is required",
        "validation_purchase_price_number": "Enter a valid price",
        "validation_purchase_price_required": "Purchase Price is required",
        "validation_required": "{{field}} is required",
        "vehicle": "Vehicle",
        "vehicle_detail": "Vehicle Detail",
        "vehicle_detail_load_error": "Vehicle details could not be loaded.",
        "vehicle_name": "Vehicle {{name}}",
        "view_vehicle": "View vehicle",
        "width": "Width",
        "year": "Year"
    },
    "landing": {
        "company_updates": {
            "title": "Company updates"
        },
        "greeting": "Hello, {{name}}!",
        "page_header": {
            "anniversaries": "Anniversaries",
            "birthdays": "Birthdays",
            "office_closure": "Office closure",
            "online": "Online"
        },
        "system_whiteboard": {
            "title": "System Whiteboard"
        },
        "upcoming_events": {
            "title": "Upcoming events"
        },
        "user_board": {
            "title": "User Board"
        }
    },
    "layout": {
        "sidebar": {
            "collapse": "Collapse sidebar",
            "expand": "Expand sidebar"
        }
    },
    "not_found": {
        "cta_authenticated": "Go to home",
        "description": "The page you are looking for does not exist or may have been moved.",
        "title": "Page not found"
    },
    "permissions": {
        "users": {
            "kc_view_user_list": "View user list"
        }
    },
    "phone_book": {
        "online": "Online"
    },
    "profile": {
        "page_title": "My Profile"
    },
    "reports": {
        "export": {
            "absence": "Absence",
            "action": "Export",
            "all_data": "All data",
            "failed": "The report could not be generated. Please try again.",
            "overtime": "Overtime",
            "period": "Period",
            "title": "Export"
        }
    },
    "settings": {
        "language": {
            "english": "English",
            "german": "German",
            "help": "Choose the application language for your account.",
            "success": "Language updated successfully.",
            "title": "Language"
        },
        "page_title": "Settings",
        "password": {
            "confirm_password": "Confirm Password",
            "otp_code": "OTP Code",
            "otp_description": "Choose a new password and enter your OTP code.",
            "reset_password": "Reset password",
            "success": "Password changed successfully.",
            "title": "Change Password",
            "validation": {
                "confirm_mismatch": "Passwords do not match",
                "confirm_required": "Password confirmation is required",
                "new_required": "New password is required",
                "requirements": "Password does not meet all requirements"
            },
            "your_otp_code": "Your OTP code"
        },
        "security_confirmation": {
            "description": "This action requires YOUR OTP code for security reasons.",
            "title": "Security confirmation"
        },
        "two_factor": {
            "cancel_failed": "Enrollment was not cancelled",
            "reset_action": "Reset two-factor authentication",
            "set_up_action": "Set up two-factor authentication",
            "status_active": "Active",
            "status_label": "Two-factor authentication",
            "status_setup_required": "Setup required",
            "title": "Two factor authentication",
            "view_code_action": "View two-factor authentication code"
        }
    },
    "sidebar": {
        "absence": "Absence",
        "admin": "Admin",
        "clients": "Clients",
        "dashboard": "Dashboard",
        "fleet": "Fleet",
        "home": "Home",
        "logout": "Logout",
        "team": "Team",
        "user_management": "User management"
    },
    "smart_date": {
        "next_years": "Next years",
        "previous_years": "Previous years"
    },
    "tasks": {
        "collapse_task_row_tooltip": "Collapse [click row]",
        "complete_task": "Complete task",
        "completed": "Completed",
        "completed_task": "Task completed",
        "copy_task": "Copy task",
        "create_new_task": "Create new task",
        "create_task": "Create Task",
        "creator": "Creator",
        "due_date": "Due Date",
        "due_date_short": "Due date",
        "due_tasks": "Due tasks",
        "edit_task_tooltip": "Edit [double-click row]",
        "estimated": "Estimated",
        "expand_task_row_tooltip": "Expand [click row]",
        "filter_label": "Task filter",
        "filter_overdue": "Overdue",
        "filter_upcoming": "Upcoming",
        "finish_current_edit_first": "Save or discard current changes first",
        "internal_notes": "Internal Notes",
        "load_failed": "Tasks could not be loaded.",
        "mark_prioritized": "Mark as prioritized",
        "no_open_tasks": "No open tasks",
        "no_overdue_tasks": "No overdue tasks",
        "no_upcoming_tasks": "No upcoming tasks",
        "open_tasks": "Open tasks",
        "overdue_tasks": "Overdue tasks",
        "person_in_charge": "Person in Charge",
        "pic": "PIC",
        "priority_abbreviated": "Prio.",
        "private": "Private",
        "private_task_tooltip": "Private tasks are never visible for anyone except you. Your deputies, managers, or HR can't see they exist.",
        "reassign": "Reassign",
        "reassign_task": "Reassign Task",
        "reopen_task": "Reopen task",
        "starred": "Starred",
        "task": "Task",
        "task_description": "Task Description",
        "unmark_prioritized": "Unmark as prioritized",
        "unstarred": "Unstarred",
        "validation_due_date_required": "Due Date is required",
        "validation_person_in_charge_required": "Person in Charge is required",
        "validation_task_description_max": "Task Description must not exceed 255 characters",
        "validation_task_description_required": "Task Description is required",
        "validation_type_required": "Type is required"
    },
    "upcoming_events": {
        "filter": {
            "birthdays": "Birthdays",
            "holidays": "Holidays",
            "vacations": "Vacations"
        },
        "type": {
            "birthday": "Birthday",
            "holiday": "Holiday",
            "vacation": "Vacation"
        }
    },
    "user_management": {
        "page_title": "User management",
        "table": {
            "branch": "Branch",
            "initials": "Initials",
            "job_title": "Job Title",
            "manager": "Manager",
            "name": "Name",
            "rank": "Rank",
            "salary_percentage": "Empl."
        }
    },
    "users": {
        "add": {
            "go_to_next_step": "Go to next step",
            "go_to_previous_step": "Go to previous step",
            "search_user": "Search user",
            "user_reference_for_autocompletion": "User reference for Autocompletion",
            "user_summary_title": "User Summary"
        },
        "add_emergency_contact": "Add emergency contact",
        "add_new_user": "Add new user",
        "add_stepper": {
            "contacts_description": "Primary and private contacts",
            "emergency_contacts_description": "Emergency contact details",
            "emergency_contacts_title": "Emergency Contacts",
            "location_description": "Address",
            "personal_description": "General and account info",
            "personal_title": "Personal",
            "professional_description": "Role and Schedule",
            "professional_title": "Professional",
            "review_description": "User Summary",
            "review_title": "Review"
        },
        "add_user": {
            "page_title": "Add user"
        },
        "birthdate": "Date of birth",
        "branch": "Branch",
        "career_development_title": "Career Development",
        "compare": {
            "page_title": "Compare User",
            "permissions": "Permissions",
            "select_user": "Select user for comparison",
            "users": "Users"
        },
        "contacts": {
            "email": "Email",
            "mobile": "Mobile",
            "name": "Name",
            "phone": "Phone",
            "private_email": "Private Email",
            "private_mobile": "Private Mobile",
            "private_phone": "Private Phone",
            "title": "Contacts"
        },
        "contacts_title": "Contact Information",
        "department": "Department",
        "deputy": "Deputy",
        "edit": {
            "page_title": "User Profile"
        },
        "email": "Email",
        "emergency_contact_indexed": "Emergency Contact {{index}}",
        "emergency_contacts_title": "Emergency Contacts",
        "events": "Events",
        "family_name": "Family name",
        "first_name": "First name",
        "hr": "HR",
        "initials": "Initials",
        "location": {
            "address": "Address 1",
            "address_plural": "Address 2",
            "city": "City",
            "country": "Country",
            "country_placeholder": "Select country",
            "postal_code": "Postal Code",
            "postcode": "Postcode",
            "title": "Location"
        },
        "location_title": "Home Address",
        "manager": "Manager",
        "new_user": "New User",
        "not_saved": "User was not saved",
        "page_title": "Users",
        "personal_information_title": "Personal Information",
        "photo": "Photo",
        "professional_information_branch": "Branch",
        "professional_information_branch_placeholder": "Select branch",
        "professional_information_department": "Department",
        "professional_information_department_placeholder": "Select department",
        "professional_information_deputy": "Deputy",
        "professional_information_deputy_placeholder": "Select deputy",
        "professional_information_direct_manager": "Direct Manager",
        "professional_information_employing_company": "Employing company",
        "professional_information_hourly_salary": "Hourly Salary",
        "professional_information_hr": "HR",
        "professional_information_hr_placeholder": "Select HR",
        "professional_information_job_title": "Job Title",
        "professional_information_job_title_placeholder": "Select job title",
        "professional_information_manager_placeholder": "Select manager",
        "professional_information_manager_required": "Direct Manager is required",
        "professional_information_monthly_salary": "Monthly Salary",
        "professional_information_percentage": "Percentage",
        "professional_information_rank": "Rank",
        "professional_information_salary": "Salary",
        "professional_information_salary_type": "Salary Type",
        "professional_information_salary_type_hourly": "Hourly",
        "professional_information_salary_type_monthly": "Monthly",
        "professional_information_self_managing": "Self-managing",
        "professional_information_team": "Team",
        "professional_information_team_placeholder": "Select team",
        "professional_information_title": "Professional Information",
        "qualification": "Qualification",
        "qualification_approved": "Qualification approved",
        "qualification_duplicate": "Identical qualification assignments are not allowed",
        "qualification_update_inactive_confirm": "This change will make a qualification inactive. Do you want to continue?",
        "qualification_update_inactive_title": "Make qualification inactive",
        "qualification_updated": "Qualifications updated",
        "relation": {
            "friend": "Friend",
            "other": "Other",
            "parent": "Parent",
            "partner": "Partner",
            "sibling": "Sibling"
        },
        "relation_title": "Relation",
        "remove_emergency_contact": "Remove emergency contact",
        "save_all_tooltip": "Save All [Ctrl+S]",
        "saved_successfully": "Saved successfully",
        "schedule_add_interval": "Add working hours",
        "schedule_apply_to_all_days": "Apply to all days",
        "schedule_apply_to_all_working_days": "Apply to all working days",
        "schedule_approve_changed": "Future schedule changed. Please review it and approve again.",
        "schedule_approve_past_confirm": "You are about to change the work schedule in the past. Do you confirm this action?",
        "schedule_approve_past_title": "Confirm past schedule change",
        "schedule_approve_success": "Schedule approved successfully",
        "schedule_approved": "Approved",
        "schedule_current": "Current",
        "schedule_day_friday": "Friday",
        "schedule_day_monday": "Monday",
        "schedule_day_saturday": "Saturday",
        "schedule_day_sunday": "Sunday",
        "schedule_day_thursday": "Thursday",
        "schedule_day_tuesday": "Tuesday",
        "schedule_day_wednesday": "Wednesday",
        "schedule_delete_future": "Reset future schedule",
        "schedule_delete_interval": "Delete working hours",
        "schedule_future": "Future",
        "schedule_hours_per_week": "40 h/per week",
        "schedule_pending": "Pending Approval",
        "schedule_total": "Total",
        "schedule_unchanged": "Schedule is unchanged.",
        "schedule_work_schedule": "Work Schedule",
        "security_language_title": "Security / Language",
        "security_title": "Security",
        "send_invite": "Send Invite",
        "signature": "Signature",
        "summary": {
            "edit_section": "Edit {{title}}",
            "fill_in_section": "Fill in the {{title}}"
        },
        "team": "Team",
        "title": "Title",
        "user_label": "User:",
        "vacation_credit_date": "Date",
        "vacation_credit_days": "Days",
        "vacation_credit_explanation": "Explanation",
        "vacation_credit_load_failed": "Vacation credits could not be loaded. Reload the page to edit them.",
        "vacation_credit_system_generated": "Credits {{year}}",
        "vacation_credit_title": "Vacation Credit",
        "validation": {
            "birthdate_required": "Date of birth is required",
            "email_invalid": "Please enter a valid email address",
            "email_required": "Email is required",
            "family_name_required": "Family name is required",
            "first_name_required": "First name is required",
            "initials_max": "Initials must be at most 3 characters",
            "initials_required": "Initials are required",
            "mobile_invalid": "Please enter a valid mobile number",
            "phone_invalid": "Please enter a valid phone number",
            "phone_required": "Phone is required",
            "salary_intervals_overlap": "Intervals overlap",
            "schedule_end_after_start": "End time must be after start time",
            "schedule_intervals_overlap": "Intervals overlap",
            "schedule_start_date_invalid": "Start date is too early",
            "schedule_time_required": "Time is required"
        },
        "view_user_profile_details_double_click_row": "View user profile details [double-click row]"
    },
    "version": {
        "update_available": {
            "action": "Reload",
            "description": "Reload the page to get the latest updates.",
            "title": "A new version is available"
        }
    },
    "whiteboard": {
        "accept": "Accept",
        "accepted": "Accepted:",
        "confirmed": "Confirmed",
        "expiration_date": "Expiration Date:",
        "form": {
            "all_users": "All Users",
            "create_company_title": "Create Company Update",
            "create_system_title": "Create System Whiteboard",
            "create_user_title": "Create User Board entry",
            "created_successfully": "Whiteboard entry created",
            "delete_dialog_text": "This entry will be removed for all recipients. This action cannot be undone.",
            "delete_dialog_title": "Delete board entry?",
            "deleted_successfully": "Whiteboard entry deleted",
            "description": "Description",
            "employing_company": "Employing Company",
            "expiration_date": "Expiration Date",
            "individual_user": "Users",
            "location": "Location",
            "no_team": "No team",
            "recipients": "Recipients",
            "title": "Title",
            "update_company_title": "Update Company Update",
            "update_system_title": "Update System Whiteboard",
            "update_user_title": "Update User Board entry",
            "updated_successfully": "Whiteboard entry updated"
        },
        "hide_confirmed": "Hide confirmed",
        "show_confirmed": "Show confirmed"
    }
}